import { createFileRoute } from "@tanstack/react-router";
import { CTABand } from "@/components/site/CTABand";
import { PhoneButton } from "@/components/site/PhoneButton";

export const Route = createFileRoute("/terms-of-service")({
  head: () => ({
    meta: [
      { title: "Terms of Use | Phoenix Plumbing Co." },
      { name: "description", content: "Terms of Use for Phoenix Plumbing Co. Read the conditions covering site use, plumbing service requests, estimates, and contact information." },
      { property: "og:title", content: "Terms of Use | Phoenix Plumbing Co." },
      { property: "og:description", content: "Terms of Use for Phoenix Plumbing Co. Read the conditions covering site use, plumbing service requests, estimates, and contact information." },
      { property: "og:url", content: "https://www.phoenixplumbing.co/terms-of-service" },
      { name: "twitter:title", content: "Terms of Use | Phoenix Plumbing Co." },
      { name: "twitter:description", content: "Terms of Use for Phoenix Plumbing Co. Read the conditions covering site use, plumbing service requests, estimates, and contact information." },
      { name: "robots", content: "noindex,follow" },
    ],
    links: [{ rel: "canonical", href: "https://www.phoenixplumbing.co/terms-of-service" }],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <section className="bg-secondary text-secondary-foreground">
        <div className="mx-auto max-w-4xl px-4 py-14">
          <h1 className="text-4xl md:text-5xl font-extrabold">Terms of Use</h1>
          <p className="mt-4 text-secondary-foreground/85 text-lg">Terms governing use of the Phoenix Plumbing Co. website and plumbing service requests.</p>
          <div className="mt-6"><PhoneButton size="lg" /></div>
        </div>
      </section>
      <article className="mx-auto max-w-3xl px-4 py-12 prose prose-lg">
        <h2>Website Information</h2>
        <p>
          The information on this website is provided for general information about Phoenix
          Plumbing Co. and our plumbing services. It is not a substitute for an in-person
          diagnosis or written estimate from a licensed plumber.
        </p>
        <h2>Service Requests</h2>
        <p>
          Submitting our form or calling us is a request for service. An appointment is not
          confirmed until our team contacts you to confirm the date, time, and scope. Timing and
          availability vary by demand and location.
        </p>
        <h2>Estimates</h2>
        <p>
          Any pricing referenced on this website is general and informational. Final pricing
          depends on on-site conditions, parts, labor, access, code requirements, and the
          overall scope of the project.
        </p>
        <h2>Website Use</h2>
        <p>
          You agree not to misuse this website, submit false information, attempt to interfere
          with site security, or use the site for any unlawful purpose.
        </p>
        <h2>Contact</h2>
        <p>Questions about these terms? Call 602-834-1208.</p>
      </article>
      <CTABand />
    </>
  );
}
